/* global swal, _, angular*/
import './style.less';
import employeeModalTemplate from 'modals/employeesSearch/index.html';
import EmployeeModalController from 'modals/employeesSearch';
import { deliveryMethods } from '@prolaera/library';
import { cloneDeep } from 'lodash';

export default function($log, $q, $uibModal, $stateParams, CategoryClass) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  let ngModelHoursTemp = false;
  let ngModelSponsorTypesTemp = false;
  let ngModelSponsorsTemp = false;
  let ngModelHoursBasicTemp = false;
  let employeesLengthTemp = false;

  vm.$doCheck = function() {
    if (!vm.employees.length) return;
    if (!angular.equals(vm.ngModel.hours, ngModelHoursTemp)) {
      ngModelHoursTemp = cloneDeep(vm.ngModel.hours);
      updateHours();
    }
    if (!angular.equals(vm.ngModel.sponsor_types, ngModelSponsorTypesTemp)) {
      ngModelSponsorTypesTemp = cloneDeep(vm.ngModel.sponsor_types);
      updateHours();
    }
    if (!angular.equals(vm.ngModel.sponsors, ngModelSponsorsTemp)) {
      ngModelSponsorsTemp = cloneDeep(vm.ngModel.sponsors);
      updateHours();
    }
    if (!angular.equals(vm.ngModel.hoursBasic, ngModelHoursBasicTemp)) {
      ngModelHoursBasicTemp = cloneDeep(vm.ngModel.hoursBasic);
      updateHours();
    }
    if (vm.employees.length !== employeesLengthTemp) {
      employeesLengthTemp = vm.employees.length;
      updateHours();
    }
  };

  vm.pagination = {
    pageSize: 10,
    pageSizes: [10, 25, 50, 100]
  };

  vm.selectAll = select => {
    vm.selectedEmployees.forEach(user => (user.selected = select));
  };

  vm.remove = index => {
    vm.employees.splice(index, 1);
    vm.safeEmployees.splice(index, 1);
  };

  vm.employees = [];

  vm.selectEmployees = () => {
    const filterEmployees = [];

    if (vm.employees.length) filterEmployees.push(...vm.employees.map(({ email }) => email));
    if (vm.ngModel && vm.ngModel.certs && vm.ngModel.certs.length)
      filterEmployees.push(...vm.ngModel.certs.map(({ email }) => email));

    $uibModal
      .open({
        backdrop: 'static',
        animation: true,
        size: 'lg',
        template: employeeModalTemplate,
        controller: EmployeeModalController(filterEmployees, undefined, undefined, true),
        controllerAs: 'employeeModalCtrl'
      })
      .result.then(users => {
        users.forEach(user => {
          user.collaspedCustomAccreditation = false;
          vm.employees.push(user);
        });
      })
      .catch(error => {
        if (error === 'backdrop click') return;
        $log.error(error);
        throw error;
      });
  };

  const formData = {
    sponsors: {},
    sponsors_types: {},
    hours_basic: {},
    hours: [
      {
        category_id: '',
        credits: '',
        subject_area: ''
      }
    ]
  };

  function updateHours() {
    for (let i = 0; i < vm.employees.length; i++) {
      if (!vm.employees[i].formData) vm.employees[i].formData = cloneDeep(formData);
      vm.employees[i].formData.hours = cloneDeep(vm.ngModel.hours);
      vm.employees[i].formData.delivery_method = cloneDeep(vm.ngModel.delivery_method);
      vm.employees[i].formData.sponsor_types = cloneDeep(vm.ngModel.sponsor_types);
      vm.employees[i].formData.sponsors = cloneDeep(vm.ngModel.sponsors);
      vm.employees[i].formData.hours_basic = cloneDeep(vm.ngModel.hours_basic);
    }
  }

  function activate() {
    $log.debug('Admin Employees Add Hour Component Activated');
    vm.loaded = false;
    vm.error = {};

    $q.all([CategoryClass.loadCategories()])
      .then(result => {
        $log.debug('Admin Employees Add Hour Component Data', result);
        const [categories] = cloneDeep(result);
        vm.categories = categories.arr;
        vm.categoryDict = categories.obj;
        vm.deliveryMethods = deliveryMethods;

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/external/attendees/controller.js